<template>
  <CSidebar
    fixed
    :minimize="minimize"
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <div class="welcome">
      <div class="name">
        <p>Hello<span class="user-name">Fank</span>,</p>
      </div>
      <div class="text">
        <p>Welcome to Recruiter Dashboard!</p>
      </div>
      <div class="line">
        <span></span>
      </div>
    </div>
    <div>
      <CRenderFunction flat :content-to-render="$options.nav" />
    </div>
    <div v-if="jobprocess" class="process-option">
      <ProcessOptionSidebar />
    </div>
    <div v-if="jobpool" class="jobpool-option">
      <JobPoolOptionSidebar />
    </div>
    <div v-if="cddpool" class="cddpool-option">
      <CddPoolOptionSidebar />
    </div>
  </CSidebar>
</template>

<script>
import nav from "./_nav";
// import JobPoolOptionSidebar from "./JobPoolOptionSidebar";
// import ProcessOptionSidebar from "./ProcessOptionSidebar";
// import CddPoolOptionSidebar from "./CddPoolOptionSidebar";
export default {
  name: "TheSidebar",
  // components: {
  //   JobPoolOptionSidebar,
  //   ProcessOptionSidebar,
  //   CddPoolOptionSidebar,
  // },
  nav,
  computed: {
    show() {
      return this.$store.state.sidebarShow;
    },
    minimize() {
      return this.$store.state.sidebarMinimize;
    },
    jobpool() {
      return this.$route.path === "/dashboard/job-pool";
    },
    jobprocess() {
      return this.$route.path === "/dashboard/recruiting-process";
    },
    cddpool() {
      return this.$route.path === "/dashboard/cdd-pool";
    },
  },
};
</script>
<style lang="scss">
@import "~@/assets/stylesheets/application";
.c-sidebar {
  background: $blue-primary;
  /* stylelint-disable-next-line declaration-no-important */
  font-family: "Poppins", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
    "Segoe UI Symbol" !important;
  overflow-y: auto;

  .welcome {
    color: $white;
    display: flex;
    flex-direction: column;
    padding: 2rem 1rem;
    padding-top: 2rem;

    .name {
      font-size: 1.25em;
      font-weight: 700;
      margin-bottom: 0.5rem;

      .user-name {
        font-style: italic;
        font-weight: 400;
        padding: 0 5px 0 10px;
      }
    }

    .text {
      font-size: 0.85em;
      opacity: 0.8;
    }

    .line {
      span {
        border-bottom: 1px solid $white;
        display: block;
        padding-bottom: 1rem;
        width: 100%;
      }
    }
  }

  .c-sidebar-nav {
    padding: 0 1rem;

    .c-sidebar-nav-link,
    .c-sidebar-nav-dropdown-toggle {
      color: $white;
      font-size: 14px;
      font-weight: 500;
      padding: 1rem 0;
      text-transform: uppercase;
      background: none;

      // &.c-active {
      //   /* stylelint-disable-next-line declaration-no-important */
      //   background: rgba(0, 0, 0, 0.2) !important;
      // }

      &:hover,
      &:focus {
        background: none;
      }
    }
    .c-sidebar-nav-dropdown.c-show {
      background: none;
    }
    .c-sidebar-nav-dropdown-items {
      background: rgba(0, 0, 0, 0.2);
      .c-sidebar-nav-item {
        .c-sidebar-nav-link {
          font-size: 13px;
          text-transform: capitalize;
          padding: 10px 0 10px 32px;
          color: rgba(255, 255, 255, 0.8);
          &:focus,
          &:hover {
            color: rgba(255, 255, 255, 1);
          }
        }
      }
    }

    .c-sidebar-nav-icon {
      flex: 0 0 45px;
      margin-left: -20px;
    }
  }
  .jobpool-option,
  .process-option,
  .cddpool-option {
    padding: 1.5rem 1rem;
  }
}

@media only screen and (max-width: 991px) {
  .c-sidebar {
    .welcome {
      padding: 1rem 1.25rem;
      padding-top: 2rem;
    }
  }
}
</style>
